import { Auth } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

interface Props {
  component: React.FC;
  accessRequired?: string[];
}
const ProtectedRoute: React.FC<Props> = ({ component, accessRequired }) => {
  const [isAuthenticated, setLoggedIn] = useState(true);
  const [canAccess, setCanAccess] = useState(false);

  useEffect(() => {
    (async () => {
      let user = null;
      let attributes: {
        [key: string]: string;
      } = {};

      try {
        user = await Auth.currentAuthenticatedUser();
        if (user) {
          setLoggedIn(true);
          attributes = (await Auth.currentSession()).getIdToken().payload;
          if (process.env.REACT_APP_OKTA_DISABLED === "true") {
            setCanAccess(true);
          } else {
            const hasRole = accessRequired?.some(
              (role) =>
                attributes[`custom:${role}`] === "true" ||
                attributes[`custom:superadmin`] === "true",
            );
            if (!accessRequired?.length || hasRole) {
              setCanAccess(true);
            } else {
              setCanAccess(false);
            }
          }
        } else {
          setLoggedIn(false);
        }
      } catch (e) {
        setLoggedIn(false);
      }
    })();
  });

  if (isAuthenticated && canAccess) {
    return React.createElement(component);
  } else if (isAuthenticated) {
    return <div>You don't have access here.</div>;
  } else {
    return <Navigate to="/login" />;
  }
};

export default ProtectedRoute;
